import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase from 'src/components/GridCellBase';
import { getBgColor } from 'src/utils/icons';

const POQty = (props: GridCellProps) => {
  const { dataItem, field = '' } = props;
  const errors = dataItem.errors[field];
  const warnings = dataItem.warnings[field];
  const infos = dataItem.informations[field];
  return (
    <GridCellBase {...props} className={getBgColor(errors, warnings, infos)}>
      {dataItem[field]}
    </GridCellBase>
  );
};

export default POQty;
